import React from "react";
import BackgroundRush from "./PageBackgrounds/BackgroundRush.jsx";
import "./Headers.css";
import Boogers from "../../media/Boogers.JPG";

export default function RushHeader() {
    return (
        <>
        <div className="Headers">
        <BackgroundRush />
        </div>
        </>
    );
}